/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionStationName
 */
export interface InspectionStationName {
    /**
     * 
     * @type {string}
     * @memberof InspectionStationName
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InspectionStationName
     */
    id?: number;
}

export function InspectionStationNameFromJSON(json: any): InspectionStationName {
    return InspectionStationNameFromJSONTyped(json, false);
}

export function InspectionStationNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionStationName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function InspectionStationNameToJSON(value?: InspectionStationName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
    };
}


